import React, { useState } from 'react';
import styled from 'styled-components';
import { IoCloseCircleSharp } from "react-icons/io5";
import image1 from '../../Assets/Images/RealEstate.png';
import image2 from '../../Assets/Images/Ecommerce2.png';
import image3 from '../../Assets/Images/ERP.png';
import image4 from '../../Assets/Images/RegNotice.png';
import image5 from '../../Assets/Images/CargoService.png';
import image6 from '../../Assets/Images/TaskManagementImage.png';
import image7 from '../../Assets/Images/ConstructionManagementImage.png';
import image8 from '../../Assets/Images/TrackingSoftware.png';
import image9 from '../../Assets/Images/DuellerEcommerce.png';
import image10 from '../../Assets/Images/SparkCargo.png';

const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
];

const Card = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (img) => {
    setSelectedImage(img);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      

      <StyledWrapper>
        <div className="container-items pb-20">
          {images.map((img, index) => (
            <button
              key={index}
              className="item-image"
              onClick={() => handleImageClick(img)}
            >
              <img src={img} alt={`img-${index}`} />
            </button>
          ))}
        </div>

        {selectedImage && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closeModal}>
                <IoCloseCircleSharp />
              </button>
              <img src={selectedImage} alt="Full View" />
            </div>
          </div>
        )}
      </StyledWrapper>
    </>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  .container-items {
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .item-image {
    position: relative;
    z-index: 1;
    transition: transform 0.3s ease, z-index 0.3s;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0 10px; /* Adjusted spacing between images */

    img {
      width: 160px;
      height: 140px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      pointer-events: none;
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: scale(1.3);
      z-index: 10;
    }

    &:hover img {
      transform: scale(1.6);
    }

    &:active img {
      transform: scale(1.1);
    }

    /* Apply slight curve transformation */
    ${[...Array(images.length).keys()].map(
      (i) => `
        &:nth-child(${i + 1}) {
          transform: translateY(${
            Math.pow((i - (images.length - 1) / 2) * 0.2, 2) * 20
          }px) rotate(${(i - (images.length - 1) / 2) * 6}deg);
        }
      `
    ).join('')}
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .modal-content {
    position: relative;
    background: #fff;
    padding: 1rem;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 70vh;
      border-radius: 6px;
    }

    .close-btn {
      position: absolute;
      top: 10px;
      right: 14px;
      border-radius: 50%;
      border: none;
      font-size: 2rem;
      color: red;
      cursor: pointer;
    }
  }
`;

export default Card;